import { API, AdmAPIList, APIList } from '@/api'
import $ from 'jquery'

const api = new AdmAPIList();
export default {

  arraySubtraction ({state}, originArray, toRemove){
    var a = originArray;
    var b = toRemove;
    var array = a.filter( function (el) { 
      return !b.includes( el ); 
    });
    console.log(originArray,toRemove);
  },

  getDataList({ state, getters, commit, dispatch }) {
    // get updated Data List from api 
    // console.log(api)
    var para = [];
    para.push({ key: 'entity', value: state.dataList.entity });
    para.push({ key: 'page', value: state.dataList.currentPage });
    para.push({ key: 'count', value: state.dataList.perPage });
    para.push({ key: 'orderBy', value: 'ID' });
    para.push({ key: 'direction', value: 'DESC' });
    para.push({ key: 'search', value: state.dataList.search });
    api.getDataList(para,
      (json) => {
        // console.log(json);
        var total = parseInt(json.data.total);
        commit({ type: 'setDataColumns', columns: json.data.columns });

        //  Array Substraction
        var fields = json.data.columns;
        var category = state.dataList.category;
        var identity = state.dataList.identity;
        var remove = state.dataList.removedColumns[category][identity];
        var add = state.dataList.addedColumns.Core;
        fields = fields.filter(function(el) {
          return remove.indexOf(el) < 0;
        });
        // Add slots
        fields = $.merge(fields, add);
        // console.log(origin,add,remove);
        // dispatch('arraySubtraction', origin, remove);

        commit({ type: 'setDataFields', fields:fields });
        commit({ type: 'setDataTotal', total: total });
        commit({ type: 'setDataList', list: json.data.list });
      },
      (error) => {
        console.error(error);
      }
    );
  },

  
  retrieveDataRecord({ state, commit }) {
    var para = [];
    para.push({ key: 'entity', value: state.dataList.entity });
    para.push({ key: 'ID', value: state.dataAction.ID });
    api.retrieveDataRecord(para,
      (json) => {
        // console.log(json);
        commit({ type: 'updateActionData', data: json.data });
      },
      (error) => {
        console.error(error);
      }
    );
  },
  createDataRecord({ state, commit, dispatch }, parameters) { // object 
    parameters.entity = state.dataList.entity;
    api.createDataRecord(parameters,
      (json) => {
        // console.log(json);
        dispatch('getDataList');
      },
      (error) => {
        console.error(error);
      }
    );
  },

  deleteDataRecord({ state, commit, dispatch }) { //object
    var parameters = {};
    parameters.entity = state.dataList.entity;
    parameters.ID = state.dataAction.ID;
    api.deleteDataRecord(parameters,
      (json) => {
        // dispatch('getDataList');
        console.log(state.dataList.identity);
        
        if(state.dataList.identity == 'document'){
          dispatch('getDocumentDataList');
        }else{
          dispatch('getDataList');
        }
      },
      (error) => {
        console.error(error);
      }
    );
  },
  updateDataRecord({ state, commit, dispatch }, parameters) { // object 
    parameters.entity = state.dataList.entity;
    api.updateDataRecord(parameters,
      (json) => {
        // console.log(json);
        dispatch('getDataList');
        commit('updateActionData',{data:{}});
      },
      (error) => {
        console.error(error);
      }
    );
  },

   getDocumentDataList({ state, getters, commit, dispatch }) {
    var para = [];
    // para.push({ key: 'entity', value: state.dataList.entity });
    para.push({ key: 'page', value: state.dataList.currentPage });
    para.push({ key: 'count', value: state.dataList.perPage });
    para.push({ key: 'orderBy', value: 'ID' });
    para.push({ key: 'direction', value: 'DESC' });
    para.push({ key: 'search', value: state.dataList.search });
    api.getDocumentList(para,
      (json) => {
        // console.log(json);
        commit({ type: 'setDataTotal', total: json.data.total });
        commit({ type: 'setDataList', list: json.data.list });
      },
      (error) => {
        console.error(error);
      }
    );
  },


  // deleteDocumentRecord({ state, commit, dispatch }) { //object
  //   var parameters = [];
  //   parameters.entity = state.dataList.entity;
  //   parameters.ID = state.dataAction.ID;
  //   api.deleteDocumentRecord(parameters,
  //     (json) => {
  //       dispatch('getDocumentDataList');
  //     },
  //     (error) => {
  //       console.error(error);
  //     }
  //   );
  // },


}



// WEBPACK FOOTER //
// ./src/Adm/EntityManagement/store/actions.js